import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function CardStatsForAdmin({
  statSubtitle,
  currency,
  statTitle,
  statTitleColor,
  statPercentColor,
  statIconName,
  statIconColor,
}) {
   
  const history=useHistory();
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg" onClick={() => history.push("/users")} style={{ cursor: "pointer" }} >
        <div className="flex-auto p-4">
          <div className="flex flex-wrap">
            <div className="relative w-full pr-4 max-w-full flex-grow flex-1">
              <h5 className="text-blueGray-400 uppercase font-bold text-xs " >
                {statSubtitle}
              </h5>
              <span className={
                "font-semibold text-xl " +
                statPercentColor 
              }
              >
                {statTitle}
              </span>

            </div>
            <div className="relative w-auto pl-4 flex-initial">
              <div
                className={
                  "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full " +
                  statIconColor
                }
              >
                <i className={statIconName}></i>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
}

CardStatsForAdmin.defaultProps = {
  statSubtitle: "Traffic",
  statTitle: "",
  statArrow: "up",
  statPercent: "",
  statPercentColor: "text-blue-500",
  statDescripiron: "Since last month",
  statIconName: "far fa-chart-bar",
  statIconColor: "bg-red-500",
  statTitleColor: "text-orange-500",

};

CardStatsForAdmin.propTypes = {
  statSubtitle: PropTypes.string,
  statTitle: PropTypes.string,
  statArrow: PropTypes.oneOf(["up", "down"]),
  statPercent: PropTypes.string,
  // can be any of the text color utilities
  // from tailwindcss
  statPercentColor: PropTypes.string,
  statDescripiron: PropTypes.string,
  statIconName: PropTypes.string,
  // can be any of the background color utilities
  // from tailwindcss
  statIconColor: PropTypes.string,
  statTitleColor: PropTypes.string,
  currency: PropTypes.string
};
